import { observer } from 'mobx-react-lite';

import { AppPage } from 'app/common/app-page/features/app-page/app-page';

import { TerminalEntityGrid } from '../features/terminal-entity-grid';

export const AllTerminalsPage = observer(() => {
  return (
    <AppPage perm="PERM_TERMINAL_READ" noWrapper>
      <TerminalEntityGrid />
    </AppPage>
  );
});
